import { render, staticRenderFns } from "./UserAchievement.vue?vue&type=template&id=784e52c4&scoped=true&"
import script from "./UserAchievement.vue?vue&type=script&lang=js&"
export * from "./UserAchievement.vue?vue&type=script&lang=js&"
import style0 from "./UserAchievement.vue?vue&type=style&index=0&id=784e52c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e52c4",
  null
  
)

export default component.exports